import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { IonSlides } from '@ionic/angular';

@Component({
  selector: 'app-widget-image-carousel-one',
  templateUrl: './widget-image-carousel-one.component.html',
  styleUrls: ['./widget-image-carousel-one.component.scss'],
})
export class WidgetImageCarouselOneComponent implements OnInit {

  @ViewChild('imageCarousel', {
    static: false
}) public imageCarousel: IonSlides;

  @Input() data: any;
  SlideOpts:any = {};
  constructor(private consoleService:ConsoleService,private widgetsService:WidgetsService) { }

  ngOnInit() {
    this.consoleService.consoleLog('widget-image-carousel-one:29 data', this.data);
    if(this.data && this.data.widgetStyle.gridColumn){
      this.setStyle()
    }
  
  }

  nextSlide() {
    this.imageCarousel.slideNext();
}
prevSlide() {
    this.imageCarousel.slidePrev();
}

  async onClickBanner(bannerData: any) {
    this.widgetsService.bannerLink(bannerData);
  }

  async setStyle(){
      
    let lgColClass = this.data.widgetStyle.gridColumn.lg;
    let mdColClass = this.data.widgetStyle.gridColumn.md;
    let smColClass = this.data.widgetStyle.gridColumn.sm;
    this.SlideOpts = {
        initialSlide: 1,
        speed: 1000,
        autoplay: false,
        spaceBetween: 20,
        slidesPerView:lgColClass,
        slidesPerGroup:lgColClass,
        breakpoints: {
    576: {
        slidesPerView: smColClass,
        slidesPerGroup:smColClass
    },
    1366: {
        slidesPerView: mdColClass,
        slidesPerGroup:mdColClass
    }
}
    }

}

}
